import Box from '@mui/material/Box'
import { IPatientReportIcon } from './patient-report-icon-types'

function SoSoIcon({
  size = 10,
  color = '#000000',
}: IPatientReportIcon): JSX.Element {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        border: `1px solid ${color}`,
        background: `linear-gradient(to right, ${color} 0% 50%, #FFF 50% 100%)`,
      }}
    />
  )
}

export default SoSoIcon
